export const PREALERTS_TEXTS = {
    TITLE: "Pre-alertanos de tu compra",
    MODAL_TITLES: {
        DECLARO: "Declaro",
        BOX_ID: "¡Compra prealertada!",
        TRACKING_ALERT: "Alto ahí vaquero",
        SECURITY_CODE: "Código de seguridad"
    },
    SIGNATURE:"Se requiere firma o código al momento de la entrega",
    BUTTON_TEXTS: {
        REVIEW: "Revisar",
        CONFIRM: "Confirmar",
        UNDERSTOOD: "Entendido",
        PREALERT_ANOTHER: "Pre-alertar otra compra",
        FINISH: "Terminar"
    }
};